/**
 * @deprecated Please consider other approaches due to the limitations of using runtime variables
 * e.g.,
 * middleware
 *
 *
 * A Wrapper that validates no built time environment variables are used
 * @param {NextConfig | (() => Promise<NextConfig>)}  nextConfig
 */
export async function withNoPublicEnvironmentVariables(nextConfig) {
    const bannedEnvVariables = Object.keys(process.env).filter(key => key.startsWith('NEXT_PUBLIC_'));
    if (bannedEnvVariables.length) {
        throw new Error(`Use of environment variables prefixed with NEXT_PUBLIC_ is prohibited,
      following env vars fail this validation: ${bannedEnvVariables}`);
    }
    let config = nextConfig;
    if (typeof nextConfig === 'function') {
        config = await nextConfig();
    }
    if (config.env && Object.keys(config.env).length) {
        throw new Error('Use of env in next.config.js is prohibited');
    }
    return config;
}
// eslint-disable-next-line deprecation/deprecation
export default withNoPublicEnvironmentVariables;
//# sourceMappingURL=withNoPublicEnvironmentVariables.js.map